module.exports = __webpack_public_path__ + "img/Flutter.3bf66d6a.png";